import { UNITS, cellArea, cellToLatLng } from 'h3-js'
import React from 'react'
import { Layer, Source } from 'react-map-gl'

export const ClustersLarge = ({
	ownedPlotIds,
	selectedPlotIds,
}: {
	ownedPlotIds: string[]
	selectedPlotIds: string[]
}) => {
	if (!ownedPlotIds.length && !selectedPlotIds.length) return null

	const uniqueSelectedPlots = [...new Set(selectedPlotIds)]

	// remove any selected plots from the owned plots
	const ownedPlotIdsFiltered = ownedPlotIds.filter(
		plot => !selectedPlotIds.includes(plot),
	)
	const uniqueOwnedPlots = [...new Set(ownedPlotIdsFiltered)]

	return (
		<>
			{uniqueOwnedPlots.map(plot => {
				// const coordinates = cellToBoundary(plot, true)
				const center = cellToLatLng(plot)
				const area = cellArea(plot, UNITS.km2)

				return (
					<React.Fragment key={`cluster-large-${plot}`}>
						{/* <Source
              type="geojson"
              data={{
                type: 'FeatureCollection',
                features: [
                  {
                    type: 'Feature',
                    geometry: {
                      type: 'Polygon',
                      coordinates: [coordinates],
                    },
                    id: plot,
                    properties: {},
                  },
                ],
              }}>
              <Layer
                {...{
                  id: `${plot}-fill-layer`,
                  type: 'fill',
                  paint: {
                    'fill-color': 'purple',
                    'fill-opacity': 0.2,
                  },
                }}
              />
              <Layer
                {...{
                  id: `${plot}-line-layer`,
                  type: 'line',
                  paint: {
                    'line-color': 'purple',
                    'line-width': 1,
                    'line-opacity': 1,
                  },
                }}
              />
            </Source> */}

						<Source
							type="geojson"
							data={{
								type: 'FeatureCollection',
								features: [
									{
										type: 'Feature',
										geometry: {
											type: 'Point',
											coordinates: [center[1], center[0]],
										},
										id: plot,
										properties: {},
									},
								],
							}}
						>
							<Layer
								{...{
									id: `${plot}-circle-layer`,
									type: 'circle',
									paint: {
										'circle-color': '#9333ea', // purple 600
										'circle-opacity': 0.3,
										'circle-radius': [
											'interpolate',
											['linear'],
											['zoom'],

											1,
											area / 750,
											6,
											area / 100,
										],
									},
								}}
							/>
						</Source>
					</React.Fragment>
				)
			})}
			{uniqueSelectedPlots.map(plot => {
				const center = cellToLatLng(plot)
				const area = cellArea(plot, UNITS.km2)

				return (
					<React.Fragment key={`cluster-large-selected-${plot}`}>
						{/* <Source
             
              type="geojson"
              data={{
                type: 'FeatureCollection',
                features: [
                  {
                    type: 'Feature',
                    geometry: {
                      type: 'Polygon',
                      coordinates: [coordinates],
                    },
                    id: plot,
                    properties: {},
                  },
                ],
              }}>
              <Layer
                {...{
                  id: `${plot}-fill-layer`,
                  type: 'fill',
                  paint: {
                    'fill-color': 'black',
                    'fill-opacity': 0.1,
                  },
                }}
              />
              <Layer
                {...{
                  id: `${plot}-line-layer`,
                  type: 'line',
                  paint: {
                    'line-color': 'black',
                    'line-width': 2,
                    'line-opacity': 1,
                    'line-dasharray': [2, 2],
                  },
                }}
              />
            </Source> */}

						<Source
							type="geojson"
							data={{
								type: 'FeatureCollection',
								features: [
									{
										type: 'Feature',
										geometry: {
											type: 'Point',
											coordinates: [center[1], center[0]],
										},
										id: plot,
										properties: {},
									},
								],
							}}
						>
							<Layer
								{...{
									id: `${plot}-circle-layer`,
									type: 'circle',
									paint: {
										'circle-color': '#475569', // slate 600
										'circle-stroke-color': '#64748b', // slate 400
										'circle-stroke-width': 1,
										'circle-stroke-opacity': 1,
										'circle-opacity': 0.2,
										'circle-radius': [
											'interpolate',
											['linear'],
											['zoom'],
											3,
											area / 750,
											6,
											area / 100,
										],
									},
								}}
							/>
						</Source>
					</React.Fragment>
				)
			})}
		</>
	)
}
